import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Article } from 'src/app/models/article';
import { Personne } from 'src/app/models/personne';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';


@Component({
  selector: 'deposerarticlesmodal',
  templateUrl: './deposerarticlesmodal.component.html',
  styleUrls: ['./deposerarticlesmodal.component.css']
})
export class DeposerarticlesmodalComponent implements OnInit {
  @ViewChild('content') modal: TemplateRef<any>;

  private articleCourant: Article = new Article();
  private totFraisDepot: number = 0.00;
  private clientCourant: Personne;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.appService.depotModal = this.modal;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 1 ? []
     : this.appService.marques.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  );

  searchType = (text$: Observable<string>) =>
    text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 1 ? []
     : this.appService.types.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  );

  initDepotArticle(client: Personne) {
    this.cumulerFraisDepot();
    this.clientCourant=client;
  }

  ajouterArticle() {
    this.articleCourant.vendeur = this.clientCourant;
    this.appService.articles.push(this.articleCourant);
    this.cumulerFraisDepot();
    
    this.appService.articlesNonVendus.push(this.articleCourant);
    
    this.articleCourant = new Article();
  }

  private cumulerFraisDepot() {
    this.appService.articles.forEach(article => {
      this.totFraisDepot += parseFloat(article.fraisDepot);
    });
  }
}
